import Loader from "react-loader-spinner";
import { X, Search, CheckLg, DashCircle } from 'react-bootstrap-icons';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { getProductGroups4Select } from '../store/api/GetAllProduct';
import { useEffect, useRef } from "react";
import { setSelectProductGroupPop } from "../store/api/Modals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
const ModalSelectProductGroup = (props) => {
    const { selectOne } = props;
    const selectedItems = useRef([]);
    const name4Search = useRef();
    const pop = useSelector(state => state.popup.popSelectPropductGroup);
    const { show, onSelect, value } = pop;
    const groupList = useSelector(state => state.ProductReducer.productGroupSelectList);
    const dispatch = useDispatch();
    const close = () => {
        selectedItems.current = [];
        onSelect(null);
        dispatch(setSelectProductGroupPop({ show: false }));
    }
    const search = (e) => {
        //check if Enter or Esape
        if (e.key) {
            if (e.key !== "Enter" && e.keyCode !== 27) {
                return;
            }
            else if (e.keyCode === 27) {
                close();
                return;
            }
        }
        dispatch(getProductGroups4Select(name4Search.current.value));
    }
    const setSelectedItems = (add, item) => {
        if (add) {
            selectedItems.current.push(item);

        }
        else {
            let indx = selectedItems.current.indexOf(item);
            selectedItems.current.splice(indx, 1);
        }
    }
    const select = () => {
        const array = selectedItems.current.slice();
        selectedItems.current = [];
        if (onSelect) {
            onSelect(array);
            dispatch(setSelectProductGroupPop({ show: false }));
        }
    }
    function selectRow(item) {
        if (!selectOne) {
            return;
        }
        if (onSelect) {
            onSelect(item);
        }
        dispatch(setSelectProductGroupPop({ show: false }));
    }
    useEffect(() => {
        if (show) {
            name4Search.current.focus();
        }
        if (value) {
            name4Search.current.value = value;
        }
    }, [show])
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle">انتخاب گروه کالا<FontAwesomeIcon icon={faTimes} size="lg" onClick={close} /></Modal.Header>
            <Modal.Body className="bodyStyle">
                <div className="form-group col-md-8">
                    <Form.Control ref={name4Search} style={{ display: "inline-block", width: "88%" }} onKeyDown={search} autoFocus />
                    <Button className="group-Btn-smalll" onClick={search}><Search size={18} /></Button>
                </div>
                <Table responsive className="fixedTable mt-2">
                    <thead>
                        <tr>
                            <th style={{ width: "10%" }}>&nbsp;</th>
                            <th style={{ width: "45%" }}>گروه اصلی</th>
                            <th style={{ width: "45%" }}>گروه فرعی</th>

                        </tr>
                    </thead>
                    <tbody>
                        {(groupList === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center", width: "100%" }}>
                                    <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                </td>
                            </tr>
                        }
                        {groupList && Array.isArray(groupList) &&
                            groupList.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => selectRow(item)}>
                                    {!selectOne &&
                                        <td style={{ width: "10%", verticalAlign: "middle" }}>
                                            <input type="checkbox" className="form-check-input" onChange={(e) => setSelectedItems(e.target.checked, item)} />
                                        </td>
                                    }
                                    <td style={{ width: selectOne ? "50%" : "45%" }}>{item.MainGroupName}</td>
                                    <td style={{ width: selectOne ? "50%" : "45%" }}>{item.GroupName}</td>

                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                {!selectOne &&
                    <Button className="group-Btn" onClick={select}><CheckLg />&nbsp;انتخاب</Button>
                }
                <Button className="group-Btn" variant="danger" onClick={close}><DashCircle size={15} />&nbsp;انصراف</Button>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectProductGroup;